import { Timer } from "@goodgamestudios/createjs-utilities";

/**
 * Dynamische Variante des Timers (es können ihm dynamisch Eigenschaften zugewiesen werden)
 *
 */
export class DynamicTimer extends Timer {
    constructor(delay: number, repeatCount: number = 0) {
        super(delay, repeatCount);
    }
}
